import { NO_REFERENCE_SENTINEL } from "@utils/catalogSubscriptions"
import replaceSlugs from "@utils/replaceSlugs"

import { Table, TopBar } from "@organisms/index"

import { AppFrame } from "@templates/index"

import { CATALOG_ROUTES } from "@routes/catalogs"

import {
    CATALOG_ITEMS_LIST_CONTROLS_ACTIVE_TAB,
    CATALOG_ITEMS_LIST_CONTROLS_KEYWORD_SEARCH,
    CATALOG_ITEMS_LIST_CONTROLS_ORDERING,
    CATALOG_ITEMS_LIST_CONTROLS_PHASE,
} from "@constants/storage"

import { useCategoriesQuery } from "./SettingsCatalogsItemList.store"
import ScopeSubscriptionCTA from "./components/ScopeSubscriptionCTA/ScopeSubscriptionCTA"
import CatalogItemTableView from "./views/CatalogItemTableView/CatalogItemTableView"

const DEFAULT_TABLE_CONFIG = {
    columnOrder: ["thumbnail_url", "name", "sku", "categories", "list_price", "customer_price", "id"],
    columnVisibility: {},
    columnPinning: {
        left: ["thumbnail_url", "name"],
    },
    sorting: [
        {
            id: "name",
            desc: false,
        },
    ],
}

function SettingsCatalogsItemListContent() {
    const windowData = window as unknown as Record<string, string | undefined>
    const catalogId = Number(windowData.CATALOG_ID)
    // The brandless "No Brand" page carries no brand id.
    const brandId = windowData.BRAND_ID ? Number(windowData.BRAND_ID) : null
    const brandName = windowData.BRAND_NAME ?? "Brand"

    // The listing endpoints address the brandless bucket by the null-scope sentinel.
    const brandParam = String(brandId ?? NO_REFERENCE_SENTINEL)

    const categoriesQuery = useCategoriesQuery(catalogId, brandParam)
    const categories = categoriesQuery.data ?? []

    const storageSlugValues = { brand: brandId === null ? `catalog-${catalogId}-no-brand` : String(brandId) }

    // The header's subscription CTA scopes itself to the active category tab, so the table
    // provider wraps the header rather than living inside the table view.
    return (
        <Table.Provider
            activePhaseStorageKey={replaceSlugs(CATALOG_ITEMS_LIST_CONTROLS_PHASE, storageSlugValues)}
            activeTabStorageKey={replaceSlugs(CATALOG_ITEMS_LIST_CONTROLS_ACTIVE_TAB, storageSlugValues)}
            searchKeywordsStorageKey={replaceSlugs(CATALOG_ITEMS_LIST_CONTROLS_KEYWORD_SEARCH, storageSlugValues)}
            orderingStorageKey={replaceSlugs(CATALOG_ITEMS_LIST_CONTROLS_ORDERING, storageSlugValues)}
            listTitle="Catalog Items"
            objectType="catalog_item"
            objectCreateRoute=""
            objectIndexName="CatalogItem"
            objectName="Catalog Item"
            defaultActivePhase="active"
            isRowClickable={true}
            isEmptyStateCreateButtonVisible={false}
            defaultTableConfigOverride={DEFAULT_TABLE_CONFIG}
        >
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle label={brandName} backDestination={CATALOG_ROUTES.LIST} />
                    </TopBar.TopBarHeaderStart>
                    <TopBar.TopBarHeaderEnd>
                        <ScopeSubscriptionCTA
                            catalogId={catalogId}
                            brandId={brandId}
                            brandName={brandName}
                            categories={categories}
                        />
                    </TopBar.TopBarHeaderEnd>
                </TopBar.Header>
            </TopBar.Root>
            <CatalogItemTableView catalogId={catalogId} brandParam={brandParam} categories={categories} />
        </Table.Provider>
    )
}

export default function SettingsCatalogsItemList() {
    return (
        <AppFrame.Root navigationType="settings">
            <SettingsCatalogsItemListContent />
        </AppFrame.Root>
    )
}
